/* Beyond Radix — recovery kit PDP behaviour (Dawn compatible, no dependencies). */
(function () {
  'use strict';
  if (window.__brPdp) return;
  window.__brPdp = true;
  document.documentElement.classList.add('br-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var slides = $$('[data-br-slide]', root);
    if (slides.length < 2) return;
    var thumbs = $$('.br-thumb[data-br-goto]', root);
    var dots = $$('[data-br-dots] span', root);
    var index = 0;
    function go(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === index;
        s.classList.toggle('is-active', on);
        if (!on) $$('video', s).forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t) {
        var on = Number(t.dataset.brGoto) === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === index); });
      var now = $('[data-br-count-now]', root);
      if (now) now.textContent = index + 1;
    }
    root.addEventListener('click', function (e) {
      var go_ = e.target.closest('[data-br-goto]');
      var step = e.target.closest('[data-br-step]');
      if (go_) go(Number(go_.dataset.brGoto));
      if (step) go(index + Number(step.dataset.brStep));
    });
    var stage = $('.br-gallery__stage', root), x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40 && !e.target.closest('model-viewer')) go(index + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* ---------- Preorder state (every br section on the page) ---------- */
  function syncPreorder(on) {
    $$('[data-br-when-preorder]').forEach(function (el) { el.hidden = !on; });
    $$('[data-br-when-stock]').forEach(function (el) { el.hidden = !!on; });
    document.documentElement.classList.toggle('br-is-preorder', !!on);
  }
  function initCountdown() {
    $$('[data-br-ship-countdown]').forEach(function (el) {
      var p = el.dataset.brShipCountdown.split('-');
      var ship = new Date(+p[0], +p[1] - 1, +p[2]);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var days = Math.round((ship - today) / 864e5);
      if (days > 0) { el.textContent = days === 1 ? 'Ships tomorrow' : 'Ships in ' + days + ' days'; el.hidden = false; }
    });
  }

  /* ---------- Product form, variants, preorder ---------- */
  function initProduct(section) {
    var form = $('[data-br-form]', section);
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse($('[data-br-variants]', section).textContent); } catch (err) {}
    var idInput = $('[data-br-variant-id]', form);
    var select = $('[data-br-variant-select]', form);
    var atc = $('[data-br-atc]', form);
    var errorEl = $('[data-br-error]', form);
    var qtyInput = $('[data-br-qty-input]', form);
    var labels = $$('[data-br-atc-label]');
    var stickyBtn = $('[data-br-sticky] [data-br-submit]', section);

    var bundleN = 1, currentV = null;
    function paintTotal() {
      if (!currentV) return;
      $$('[data-br-btn-total]', section).forEach(function (el) { el.textContent = bundleN === 2 && currentV.price2 ? currentV.price2 : currentV.price; });
      $$('[data-br-price-2]', section).forEach(function (el) { if (currentV.price2) el.textContent = currentV.price2; });
    }
    function applyVariant(v) {
      if (!v) return;
      currentV = v;
      idInput.value = v.id;
      var label = !v.available ? atc.dataset.labelSoldout : (v.preorder ? atc.dataset.labelPreorder : atc.dataset.labelAdd);
      labels.forEach(function (l) { l.textContent = label; });
      atc.disabled = !v.available;
      $$('[data-br-submit]').forEach(function (b) { b.disabled = !v.available; });
      $$('[data-br-price-now]').forEach(function (el) { el.textContent = v.price; });
      $$('[data-br-price-was]').forEach(function (el) { el.hidden = !v.compare; if (v.compare) el.textContent = v.compare; });
      var save = $('[data-br-price-save]', section);
      if (save) { save.hidden = !v.save; save.textContent = 'Save ' + v.save + '%'; }
      $$('[data-br-preorder-prop]', form).forEach(function (el) { el.disabled = !v.preorder; });
      syncPreorder(v.preorder);
      paintTotal();
      var dyn = $('[data-br-dynamic]', section);
      if (dyn) dyn.hidden = v.preorder;
      if (window.history.replaceState && select) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var first = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0];
    if (first) { currentV = first; syncPreorder(first.preorder); }
    var bundle = $('[data-br-bundle]', section);
    if (bundle) bundle.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      bundleN = Number(e.target.value) || 1;
      qtyInput.value = bundleN;
      paintTotal();
    });
    labels.forEach(function (l) { if (!l.closest('[data-br-form]') && !l.closest('[data-br-sticky]')) l.textContent = $('[data-br-atc-label]', form).textContent.trim(); });
    if (select) select.addEventListener('change', function () {
      applyVariant(variants.filter(function (v) { return String(v.id) === select.value; })[0]);
    });

    $$('[data-br-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(20, (parseInt(qtyInput.value, 10) || 1) + Number(b.dataset.brQty)));
        qtyInput.value = n;
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      errorEl.hidden = true;
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');

      // Dawn's cart drawer / cart notification re-render from the sections returned by /cart/add.
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var data = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        data.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            errorEl.textContent = res.description || res.message || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
            return;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'br-pdp', productVariantId: idInput.value, cartData: res });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          atc.classList.add('is-added');
          setTimeout(function () { atc.classList.remove('is-added'); }, 1600);
        })
        .catch(function () {
          errorEl.textContent = 'We could not reach the cart. Check your connection and try again.';
          errorEl.hidden = false;
        })
        .finally(function () {
          atc.classList.remove('is-loading');
          atc.removeAttribute('aria-busy');
        });
    });

    // Sticky add to cart appears once the main button scrolls out of view.
    var sticky = $('[data-br-sticky]', section);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
    }
  }

  /* ---------- Dialogs (kit guide, manual preview) ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-br-open]');
    if (opener) {
      var dlg = document.getElementById(opener.dataset.brOpen);
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        var focusId = opener.dataset.brFocus;
        $$('.is-focus', dlg).forEach(function (el) { el.classList.remove('is-focus'); });
        if (focusId) {
          var target = document.getElementById(focusId);
          if (target) { target.classList.add('is-focus'); target.focus(); target.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); }
        }
      }
      return;
    }
    if (e.target.closest('[data-br-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('br-dialog')) e.target.close();

    var submit = e.target.closest('[data-br-submit]');
    if (submit && !submit.disabled) {
      var f = document.querySelector('[data-br-form]');
      var a = f && $('[data-br-atc]', f);
      if (a) {
        submit.classList.add('is-loading');
        var obs = new MutationObserver(function () { if (!a.classList.contains('is-loading')) { submit.classList.remove('is-loading'); obs.disconnect(); } });
        obs.observe(a, { attributes: true, attributeFilter: ['class'] });
        if (typeof f.requestSubmit === 'function') f.requestSubmit(a); else a.click();
      }
      return;
    }

    var chip = e.target.closest('[data-br-situ] [role="radio"]');
    if (chip) {
      var box = chip.closest('[data-br-situ]');
      var on = chip.getAttribute('aria-checked') !== 'true';
      $$('[role="radio"]', box).forEach(function (c) { c.setAttribute('aria-checked', c === chip && on ? 'true' : 'false'); });
      var tip = $('[data-br-situ-tip]', box), text = $('[data-br-situ-text]', box);
      if (!text.dataset.hint) text.dataset.hint = text.textContent;
      text.textContent = on ? chip.dataset.tip : text.dataset.hint;
      tip.classList.toggle('is-set', on);
      tip.classList.remove('is-flash'); void tip.offsetWidth; tip.classList.add('is-flash');
      return;
    }

    var scrollBuy = e.target.closest('[data-br-scroll-buy]');
    if (scrollBuy) {
      var buy = document.querySelector('[data-br-buy]');
      if (buy) { e.preventDefault(); buy.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
    }

    var more = e.target.closest('[data-br-faq-more]');
    if (more) {
      var wrap = more.closest('[data-br-faq]');
      var extras = $$('[data-br-extra]', wrap);
      var opening = extras.length && extras[0].hidden;
      extras.forEach(function (x) { x.hidden = !opening; });
      if (!more.dataset.more) more.dataset.more = more.textContent;
      more.textContent = opening ? more.dataset.less : more.dataset.more;
    }

    var car = e.target.closest('[data-br-car]');
    if (car) {
      var track = $('[data-br-car-track]', car.closest('[data-br-carousel]'));
      track.scrollBy({ left: Number(car.dataset.brCar) * track.clientWidth * 0.9, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  });

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var tabs = $$('[role="tab"]', root);
    function select(tab) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
        if (!d) return;
        var next = tabs[(i + d + tabs.length) % tabs.length];
        e.preventDefault(); select(next); next.focus();
      });
    });
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.remove('is-pre'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.br-reveal').forEach(function (el) {
      if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('is-pre'); io.observe(el); }
    });
  }

  /* ---------- Recovery path: progress line + phase meter ---------- */
  function initPath(list) {
    var section = list.closest('section');
    var phases = $$('[data-br-phase]', list);
    var now = $('[data-br-phase-now]', section);
    var ticking = false;
    function update() {
      ticking = false;
      var r = list.getBoundingClientRect(), mid = window.innerHeight * 0.55;
      var p = Math.max(0, Math.min(1, (mid - r.top) / r.height));
      section.style.setProperty('--br-p', p.toFixed(3));
      section.style.setProperty('--br-trail', Math.max(0, Math.min(r.height - 48, mid - r.top - 24)) + 'px');
      var current = phases[0];
      phases.forEach(function (ph) {
        var on = ph.getBoundingClientRect().top < mid;
        ph.classList.toggle('is-on', on);
        if (on) current = ph;
      });
      if (now && current) now.textContent = current.dataset.brPhase;
      var name = $('[data-br-phase-name]', section);
      if (name && current && name.textContent !== current.dataset.brPhaseTitle) name.textContent = current.dataset.brPhaseTitle || '';
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    list.addEventListener('toggle', onScroll, true);
    update();
  }

  function initCountUp() {
    var els = $$('[data-br-countup]');
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, end = parseInt(el.dataset.brEnd, 10), t0 = null;
        function step(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / 900); el.textContent = Math.round(end * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) {
      if (el.dataset.brEnd) return;
      el.dataset.brEnd = el.textContent.trim();
      if (el.getBoundingClientRect().top > window.innerHeight) { el.textContent = '0'; io.observe(el); }
    });
  }

  /* ---------- Tool tray ---------- */
  function initTray(tray) {
    var btns = $$('.br-tool__btn', tray);
    var cap = $('.br-tray__caption', tray);
    function pick(b) {
      btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      $('[data-br-tray-name]', tray).textContent = b.dataset.name + '.';
      $('[data-br-tray-text]', tray).textContent = b.dataset.text;
      var tag = $('[data-br-tray-tag]', tray); tag.textContent = b.dataset.tag; tag.hidden = !b.dataset.tag;
      cap.classList.remove('is-flash'); void cap.offsetWidth; cap.classList.add('is-flash');
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { pick(b); });
      b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) pick(b); });
    });
    if ('IntersectionObserver' in window && !reduceMotion) {
      tray.classList.add('is-pre');
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { tray.classList.remove('is-pre'); tray.classList.add('is-in'); io.disconnect(); } }, { threshold: 0.2 });
      io.observe(tray);
    }
  }

  function initMarks() {
    var marks = $$('.br-mark');
    if (reduceMotion || !('IntersectionObserver' in window)) { marks.forEach(function (m) { m.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { threshold: 1, rootMargin: '0px 0px -10% 0px' });
    marks.forEach(function (m) { io.observe(m); });
  }

  function init(scope) {
    $$('[data-br-gallery]', scope).forEach(initGallery);
    $$('[data-br-product]', scope).forEach(initProduct);
    $$('[data-br-tabs]', scope).forEach(initTabs);
    $$('[data-br-path]', scope).forEach(initPath);
    initCountdown();
    $$('[data-br-tray]', scope).forEach(initTray);
    initMarks();
    initCountUp();
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
